import googlePlayStore from "../assets/images/google_play_store.svg";
import iosAppStore from "../assets/images/ios_app_store.svg";
import Text from "../components/Text";
import IconText from "../components/IconText";
import { ImFacebook2 } from "react-icons/im";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="">
      <div className="footer-wrapper m-auto w-[95%] max-w-[1400px] md:px-8">
        <div className="content pt-12 text-[13px] text-[#3E3E3E]">
          {/* <div className="logo px-4 mb-4">
            <img src={logo} alt="" className="w-40" />
          </div> */}
          <div className="links-group my-8 flex">
            {/* <div className="follow-us-links mb-7 px-4">
              <div className="heading capitalize text-sm text-white">
                <Text component={"h5"} text="Follow us" />
              </div>
              <ul className="links flex pt-2 text-base">
                {Array(4)
                  .fill("")
                  .map((item, index) => (
                    <li className="mr-2 last:ml-0" key={index}>
                      <a href="#" className="hover:text-white">
                        <IconText iconInfo={{ Icon: ImFacebook2 }} />
                      </a>
                    </li>
                  ))}
              </ul>
            </div> */}
            <div className="other-links flex flex-auto flex-wrap  justify-between justify-items-stretch">
              <div className="links mb-7 px-4">
                <div className="heading mb-2 font-bold">
                  <Text text="Gepzo" />
                </div>
                <ul className="links flex flex-col">
                  <li>
                    <Link
                      to={"everyone/about"}
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      About Gepzo
                    </Link>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Press
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Careers
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Become a Partner
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Partner Marketplace
                    </a>
                  </li>
                </ul>
              </div>
              <div className="links mb-7 px-4">
                <div className="heading mb-2 font-bold">
                  <Text text="Explore" />
                </div>
                <ul className="links flex flex-col">
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Find a Nutritionist
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Shop Healthy
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Monthly Box
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      The Blog
                    </a>
                  </li>
                </ul>
              </div>
              <div className="links mb-7 px-4">
                <div className="heading mb-2 font-bold">
                  <Text text="Support" />
                </div>
                <ul className="links flex flex-col">
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Help
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
              <div className="links mb-7 px-4">
                <div className="heading mb-2 font-bold">
                  <Text text="Dietitian" />
                </div>
                <ul className="links flex flex-col">
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Product Overview
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      List your Product
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Demo
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Support
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      Staff Login
                    </a>
                  </li>
                </ul>
              </div>
              <div className="links mb-7 px-4">
                <div className="heading mb-2 font-bold">
                  <Text text="Gepzo App" />
                </div>
                <ul className="links flex flex-col">
                  <li className="">
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      <img
                        src={googlePlayStore}
                        alt=""
                        className="max-w-[130px] w-full bg-black rounded-[10px]"
                      />
                    </a>
                  </li>
                  <li className="">
                    <a
                      href="#"
                      className="py-[6px] transition-all duration-200 hover:text-black inline-block"
                    >
                      <img
                        src={iosAppStore}
                        alt=""
                        className="max-w-[130px] w-full bg-black rounded-[10px]"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="links mb-7 px-4">
                <div className="heading mb-2 font-bold">
                  <Text component={"h5"} text="Follow us" />
                </div>
                <ul className="links flex pt-2 text-base text-[#D66D5A]">
                  {Array(4)
                    .fill("")
                    .map((item, index) => (
                      <li className="mr-2 last:ml-0" key={index}>
                        <a href="#" className="">
                          <IconText iconInfo={{ Icon: ImFacebook2 }} />
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="copyrights flex justify-center">
            <div className="py-5">
              <Text>Copyright &copy; Gepzo 2022.</Text>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
